import { defineComponent as _defineComponent } from 'vue'
import Navigation from "../../NavigationContainer.vue";
import { ref, onMounted, reactive, onUpdated, watch } from "vue";
import { useI18n } from "vue3-i18n";
import { store } from "@/store/store";
import ResponseData from "@/types/ResponseData";
import FileData from "@/types/FileData";
import PcFileDataService from "@/services/PcFileDataService";
import Loading from "@/components/home/Loading";
import Alert from "@/components/scan/parts/Alert.vue";
import Manual from "@/components/scan/parts/Manual";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const downloadFiles = reactive([]);
const uniqueDataID = reactive([]);
const uniqueFromStaion = reactive([]);
const fileBody = reactive([]);
const isDownloaded = ref("notDownloaded");
const selectDataId = ref("ALL DATA ID");
const selectFromStation = ref("ALL STATION");
const isLoading = ref(false);
const controlIdList = reactive([]);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const isOnedownload = ref(false);
const isAuthUser = ref(false);
const isEnableDownload = ref(false);
const isDownloadFileLoaded = ref(false);
const isDownloadBannerMsg = ref(0);
const startDate = ref(new Date().toISOString().slice(0, 10));
const endDate = ref(new Date(Date.now() - 518400000).toISOString().substring(0, 10));
// for SCAN-PC Datat Pagination
const SCANAllRowtable = reactive([]);
const SCANPageMaxRow = ref(50);
const SCANPageCount = ref(1);
const SCANPageNumber = ref(1);
const SCANNextBtnText = ref("Next >>");
const SCANBackBtnText = ref("<< Back");
const SCANSelectedOptionRows = reactive([]);
const SCANAllRowLenght = ref(0);
const SCANPageShowLenght = ref(0);

// for PORD Preview
const PORDTitle = ref("<Transmission Inquiry(Part Order Detail)>");
const PORDHeader = reactive([]);
const PORDDatatable = reactive([]);
const PORDTenRowtable = reactive([]);
const PORDPageCount = ref(1);
const PORDPageNumber = ref(1);
const PORDBackBtnText = ref("<< Back");

// for PINV Preview
const PINVTitle = ref("<Transmission Inquiry ( Part Invoice Detail ) >");
const PINVHeader = reactive([]);
const PINVDatatable = reactive([]);

const CaseDetailTitle = ref("<Transmission Inquiry ( Part Invoice Case Detail ) >");
const CaseDetailDatatable = reactive([]);
const CaseDetailHeader = reactive([]);
const CaseDetailSplitData = reactive([]);
const destinationList = reactive([]);
const selectedDestination = ref("");

onMounted(function () {
  isLoading.value = true;
  if (store.getters.stationListData != null) {
    destinationList.splice(0);
    destinationList.push(store.getters.stationListData);
  }
  if (store.getters.stationCode != "") {
    selectedDestination.value = store.getters.selectedStation == null ? store.getters.stationCode : store.getters.selectedStation;
    getFilesByToStationCodeAllData();
    isDownloadFileLoaded.value = true;
  }
});
watch(
  () => [store.getters.stationListData],
  function () {
    if (store.getters.stationListData != null) {
      destinationList.splice(0);
      destinationList.push(store.getters.stationListData);
      if (!isDownloadFileLoaded.value) {
        selectedDestination.value = store.getters.selectedStation == null ? store.getters.stationCode : store.getters.selectedStation;
        getFilesByToStationCodeAllData();
        isDownloadFileLoaded.value = true;
      }
    }
  }
);

/** 選択しているDataIDを一括ダウンロードする関数 */
const pcBatchDownload = async () => {
  selectedDestination.value = selectedDestination.value == "" ? store.getters.stationCode : selectedDestination.value;
  const allFileBody = ref("");
  isLoading.value = true;
  controlIdList.splice(0);
  try {
    for (let idxVal = 0; idxVal < SCANSelectedOptionRows[0].length; idxVal++) {
      controlIdList.push(SCANSelectedOptionRows[0][idxVal].id);
      allFileBody.value = allFileBody.value + SCANSelectedOptionRows[0][idxVal].fileBody;
    }
    setDownloadFlag(null, allFileBody.value);
  } catch (e) {
    console.log(e);
    alertMessage.value = i18n.t("err003");
    alertState.value = "error";
    isLoading.value = false;
  }
};

const createText = (allFileBody: string) => {
  try {
    const blob = new Blob([allFileBody], {
      type: "text/plain",
    });
    const downloadlink = document.createElement("a");
    const date = new Date();
    const downloadDate =
      ("00" + (date.getMonth() + 1)).slice(-2) +
      ("00" + date.getDate()).slice(-2) +
      date.getFullYear() +
      ("00" + date.getHours()).slice(-2) +
      ("00" + date.getMinutes()).slice(-2) +
      ("00" + date.getSeconds()).slice(-2);
    downloadlink.href = URL.createObjectURL(blob);
    downloadlink.download = selectDataId.value + "_" + downloadDate + ".txt";
    downloadlink.click();
  } catch (e) {
    console.log(e);
    alertMessage.value = i18n.t("err002");
    alertState.value = "error";
  }
};

/** StartDate値の変更処理 */
const startDateChange = (event: { target: { value: any; }; }) => {
  if (!isNaN(new Date(event.target.value))) {
    startDate.value = event.target.value;
    getFilesByToStationCodeAllData();
  } else {
    alert("Please input valid date.");
  }
};

const blockInput = (event: { target: { value: any; }; }) => {
  event.preventDefault();
  return false;
};

/** DataIDをALL DATA IDで指定してファイルを取得する関数 */
const getFilesByToStationCodeAllData = () => {
  selectDataId.value = "ALL DATA ID";
  selectFromStation.value = "ALL STATION";
  isLoading.value = true;
  getFilesByToStationCode();
};

/** ステーションコードに対応したファイルを取得する関数 */
const getFilesByToStationCode = () => {
  selectedDestination.value = selectedDestination.value == "" ? store.getters.stationCode : selectedDestination.value;
  uniqueDataID.splice(0);
  uniqueFromStaion.splice(0);
  downloadFiles.splice(0);
  SCANAllRowtable.splice(0);
  SCANSelectedOptionRows.splice(0);
  const toStationCodeDL = {
    toStationCode: selectedDestination.value,
    isDownloaded: isDownloaded.value,
    selectDataId: selectDataId.value,
    loginUserId: store.getters.cognitoUserName,
    loginUserStationCode: store.getters.stationCode,
    startDate: startDate.value,
  };
  PcFileDataService.allDownload(toStationCodeDL)
    .then((response: ResponseData) => {
      var data = response.data["pcFileData"];
      isAuthUser.value = response.data["isAuthUser"];
      isEnableDownload.value = response.data["isEnableDownload"];
      isDownloadBannerMsg.value = response.data["bannerMsgFlg"];
      var returnSearchDate = response.data["returnSearchDate"];
      var returnEndDate = response.data["returnEndDate"];
      returnSearchDate = returnSearchDate.slice(0, 10);
      if (returnSearchDate != startDate.value) {
        var message = i18n.t("alt083");
        message = message.replaceAll("{oldStartDate}", returnSearchDate).replaceAll("{newStartDate}", returnSearchDate);
        alert(message);
        startDate.value = returnSearchDate;
      }
      endDate.value = returnEndDate.slice(0, 10);
      if (data != undefined) {
        SCANAllRowtable.push(data);
        SCANSelectedOptionRows.push(data);
        SCANPageCount.value = Math.ceil(SCANAllRowtable[0].length / SCANPageMaxRow.value);
        SCANPageNumber.value = 1;
        downloadFiles.splice(0);
        for (let i = 0; i < data.length; i++) {
          if (i < SCANPageMaxRow.value) {
            const date = new Date(Date.parse(data[i].uploadDate));
            data[i].uploadDate = date.toLocaleString("en-US", { hour12: false });
            downloadFiles.push(data[i]);
          } else {
            break;
          }
        }
        uniqueDataID.push([...new Set(data.map((item: { dataId: any; }) => item.dataId))].sort());
        uniqueFromStaion.push([...new Set(data.map((item2: { fromStationCode: { stationCode: any; }; }) => item2.fromStationCode_id))].sort());
        SCANAllRowLenght.value = SCANAllRowtable[0].length;
        SCANPageShowLenght.value = downloadFiles.length;
      }
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err004");
      alertState.value = "error";
      isLoading.value = false;
    });
};

const changeSCANPage = (direction) => {
  downloadFiles.splice(0);
  var startIndex = 0;
  var endIndex = 0;
  if (direction == "Next") {
    startIndex = SCANPageNumber.value * SCANPageMaxRow.value;
    endIndex = (SCANPageNumber.value * SCANPageMaxRow.value) + SCANPageMaxRow.value;
    if (endIndex >= SCANAllRowtable[0].length) {
      endIndex = SCANAllRowtable[0].length;
    }
    SCANPageNumber.value = SCANPageNumber.value + 1;
  } else {
    startIndex = ((SCANPageNumber.value - 1) * SCANPageMaxRow.value) - SCANPageMaxRow.value;
    endIndex = (SCANPageNumber.value * SCANPageMaxRow.value) - SCANPageMaxRow.value;
    SCANPageNumber.value = SCANPageNumber.value - 1;
  }
  // filter rows count and real all row count check
  if (SCANAllRowtable[0].length != SCANSelectedOptionRows[0].length) {
    if (endIndex >= SCANSelectedOptionRows[0].length) {
      endIndex = SCANSelectedOptionRows[0].length;
    }
    for (var i = startIndex; i < endIndex; i++) {
      var date1 = new Date(Date.parse(SCANSelectedOptionRows[0][i].uploadDate));
      SCANSelectedOptionRows[0][i].uploadDate = date1.toLocaleString("en-US", { hour12: false });
      downloadFiles.push(SCANSelectedOptionRows[0][i]);
    }
    SCANAllRowLenght.value = SCANSelectedOptionRows[0].length;
    SCANPageShowLenght.value = downloadFiles.length + (SCANPageMaxRow.value * (SCANPageNumber.value - 1));
  } else {
    for (var j = startIndex; j < endIndex; j++) {
      var date2 = new Date(Date.parse(SCANAllRowtable[0][j].uploadDate));
      SCANAllRowtable[0][j].uploadDate = date2.toLocaleString("en-US", { hour12: false });
      downloadFiles.push(SCANAllRowtable[0][j]);
    }
    SCANAllRowLenght.value = SCANAllRowtable[0].length;
    SCANPageShowLenght.value = downloadFiles.length + (SCANPageMaxRow.value * (SCANPageNumber.value - 1));
  }
};

/** プレビューボタン押下時の処理関数 */
const modalClick = (index) => {
  fileBody.splice(0);
  for (let key of Object.keys(downloadFiles)) {
    if (key == index) {
      fileBody.push(downloadFiles[key].fileBody);
      break;
    }
  }
};

const PORDModalClick = (index, file) => {
  PORDHeader.splice(0);
  fileBody.splice(0);
  PORDDatatable.splice(0);
  PORDTenRowtable.splice(0);
  for (let key of Object.keys(downloadFiles)) {
    if (key == index) {
      fileBody.push(downloadFiles[key].fileBody.trim());
      break;
    }
  }
  var splitData = [];
  var fileDataIndex = fileBody[0].indexOf("\r\n");
  splitData = fileBody[0].split("\r\n");
  if (fileDataIndex == -1) {
    fileDataIndex = fileBody[0].indexOf("\r");
    splitData = fileBody[0].split("\r");
    if (fileDataIndex == -1) {
      fileDataIndex = fileBody[0].indexOf("\n");
      splitData = fileBody[0].split("\n");
    }
  }
  // Header Section
  var fromCompanyName = destinationList[0].filter((stData: { stationCode: any; }) => stData.stationCode == file.fromStationCode_id)
  var toCompanyName = destinationList[0].filter((stData: { stationCode: any; }) => stData.stationCode == file.toStationCode_id)
  PORDHeader.push(fromCompanyName.length > 0 ? fromCompanyName[0].companyName : "");
  PORDHeader.push(toCompanyName.length > 0 ? toCompanyName[0].companyName : "");

  // Title Section
  var headerSec = splitData[1];
  PORDHeader.push(headerSec.length >= 8 ? headerSec.substr(1, 7) : "");
  PORDHeader.push(headerSec.length >= 14 ? headerSec.substr(8, 6) : "");
  var strDTFormat1 = headerSec.length >= 20 ? headerSec.substr(14, 6).trim() : "";
  if (strDTFormat1.length == 6) {
    strDTFormat1 = strDTFormat1.substr(0, 2) + "/" + strDTFormat1.substr(2, 2) + "/" + strDTFormat1.substr(4);
  }
  PORDHeader.push(strDTFormat1);
  PORDHeader.push(headerSec.length >= 24 ? parseInt(headerSec.substr(20, 4)) : "");
  PORDHeader.push(headerSec.length >= 25 ? headerSec.substr(24, 1) : "");
  var strDTFormat2 = headerSec.length >= 31 ? headerSec.substr(25, 6).trim() : "";
  if (strDTFormat2.length == 6) {
    strDTFormat2 = strDTFormat2.substr(0, 2) + "/" + strDTFormat2.substr(2, 2) + "/" + strDTFormat2.substr(4);
  }
  PORDHeader.push(strDTFormat2);

  // Body Section
  var bodyRowCount = splitData.length - 2;
  PORDPageCount.value = Math.ceil(bodyRowCount / 10);
  PORDPageNumber.value = 1;
  var bodyRowData = {};
  var rowData;
  for (var count = 0; count < bodyRowCount; count++) {
    rowData = splitData[count + 2];
    bodyRowData = {
      "Item1": rowData.length >= 5 ? rowData.substr(1, 4) : "",
      "PartNo1": rowData.length >= 20 ? rowData.substr(5, 15) : "",
      "Qty1": rowData.length >= 26 ? parseInt(rowData.substr(20, 6)) : "",
      "Bin1": rowData.length >= 33 ? rowData.substr(26, 7) : "",
      "Item2": rowData.length >= 40 ? rowData.substr(36, 4) : "",
      "PartNo2": rowData.length >= 55 ? rowData.substr(40, 15) : "",
      "Qty2": rowData.length >= 61 ? parseInt(rowData.substr(55, 6)) : "",
      "Bin2": rowData.length >= 68 ? rowData.substr(61, 7) : ""
    };
    PORDDatatable.push(bodyRowData);
    if (count < 10) {
      PORDTenRowtable.push(bodyRowData);
    }
  }
};

const changePORDPage = (direction: string) => {
  PORDTenRowtable.splice(0);
  var startIndex = 0;
  var endIndex = 0;
  var bodyRowData = {};
  if (direction == "Next") {
    startIndex = PORDPageNumber.value * 10;
    endIndex = (PORDPageNumber.value * 10) + 10;
    if (endIndex >= PORDDatatable.length) {
      endIndex = PORDDatatable.length;
    }
    PORDPageNumber.value = PORDPageNumber.value + 1;
  } else {
    startIndex = ((PORDPageNumber.value - 1) * 10) - 10;
    endIndex = (PORDPageNumber.value * 10) - 10;
    PORDPageNumber.value = PORDPageNumber.value - 1;
  }
  for (var i = startIndex; i < endIndex; i++) {
    bodyRowData = {
      "Item1": PORDDatatable[i]["Item1"],
      "PartNo1": PORDDatatable[i]["PartNo1"],
      "Qty1": PORDDatatable[i]["Qty1"],
      "Bin1": PORDDatatable[i]["Bin1"],
      "Item2": PORDDatatable[i]["Item2"],
      "PartNo2": PORDDatatable[i]["PartNo2"],
      "Qty2": PORDDatatable[i]["Qty2"],
      "Bin2": PORDDatatable[i]["Bin2"]
    };
    PORDTenRowtable.push(bodyRowData);
  }
};

const PINVModalClick = (index: string, file: { fromStationCode_id: any; toStationCode_id: any; }) => {
  fileBody.splice(0);
  for (let key of Object.keys(downloadFiles)) {
    if (key == index) {
      fileBody.push(downloadFiles[key].fileBody);
      break;
    }
  }
  var splitData = [];
  var fileDataIndex = fileBody[0].indexOf("\r\n");
  splitData = fileBody[0].split("\r\n");
  if (fileDataIndex == -1) {
    fileDataIndex = fileBody[0].indexOf("\r");
    splitData = fileBody[0].split("\r");
    if (fileDataIndex == -1) {
      fileDataIndex = fileBody[0].indexOf("\n");
      splitData = fileBody[0].split("\n");
    }
  }
  CaseDetailSplitData.value = splitData;
  PINVHeader.splice(0);
  // Header Section
  var fromCompanyName = destinationList[0].filter((stData: { stationCode: any; }) => stData.stationCode == file.fromStationCode_id)
  var toCompanyName = destinationList[0].filter((stData: { stationCode: any; }) => stData.stationCode == file.toStationCode_id)
  PINVHeader.push(fromCompanyName.length > 0 ? fromCompanyName[0].companyName : "");
  PINVHeader.push(toCompanyName.length > 0 ? toCompanyName[0].companyName : "");

  // Title Section One
  var headerSec1 = splitData[1];
  PINVHeader.push(headerSec1.length >= 7 ? headerSec1.substr(2, 5) : "");
  PINVHeader.push(headerSec1.length >= 2 ? (headerSec1.substr(1, 1) != "" ? "*" : "") : "");
  PINVHeader.push(headerSec1.length >= 10 ? parseInt(headerSec1.substr(7, 3)) : "");
  PINVHeader.push(headerSec1.length >= 14 ? parseInt(headerSec1.substr(10, 4)) : "");
  PINVHeader.push(headerSec1.length >= 15 ? headerSec1.substr(14, 1) : "");
  PINVHeader.push(headerSec1.length >= 16 ? headerSec1.substr(15, 1) : "");
  PINVHeader.push(headerSec1.length >= 20 ? headerSec1.substr(16, 4) : "");

  var currency = headerSec1.length >= 16 ? headerSec1.substr(15, 1) : "";
  PINVHeader.push(headerSec1.length >= 29 ? (currency == "N" ? parseInt(headerSec1.substr(20, 9)).toLocaleString() : (parseFloat(headerSec1.substr(20, 9)) / 100)).toLocaleString("ja-JP", { minimumFractionDigits: 2 }) : "");
  PINVHeader.push(headerSec1.length >= 38 ? (currency == "N" ? parseInt(headerSec1.substr(29, 9)).toLocaleString() : (parseFloat(headerSec1.substr(29, 9)) / 100)).toLocaleString("ja-JP", { minimumFractionDigits: 2 }) : "");
  PINVHeader.push(headerSec1.length >= 46 ? (currency == "N" ? parseInt(headerSec1.substr(38, 8)).toLocaleString() : (parseFloat(headerSec1.substr(38, 8)) / 100)).toLocaleString("ja-JP", { minimumFractionDigits: 2 }) : "");
  PINVHeader.push(headerSec1.length >= 54 ? (currency == "N" ? parseInt(headerSec1.substr(46, 8)).toLocaleString() : (parseFloat(headerSec1.substr(46, 8)) / 100)).toLocaleString("ja-JP", { minimumFractionDigits: 2 }) : "");
  var strDT1 = headerSec1.length >= 80 ? headerSec1.substr(74, 6).trim() : "";
  if (strDT1.length == 6) {
    strDT1 = strDT1.substr(0, 2) + "/" + strDT1.substr(2, 2) + "/" + strDT1.substr(4);
  }
  PINVHeader.push(strDT1);
  // Title Section Two
  var headerSec2 = splitData[2];
  PINVHeader.push(headerSec2.length >= 26 ? headerSec2.substr(1, 25) : "");
  var strDT2 = headerSec2.length >= 57 ? headerSec2.substr(51, 6).trim() : "";
  if (strDT2.length == 6) {
    strDT2 = strDT2.substr(0, 2) + "/" + strDT2.substr(2, 2) + "/" + strDT2.substr(4);
  }
  PINVHeader.push(strDT2);
  PINVHeader.push(headerSec2.length >= 51 ? headerSec2.substr(26, 25) : "");
  var strDT3 = headerSec2.length >= 63 ? headerSec2.substr(57, 6).trim() : "";
  if (strDT3.length == 6) {
    strDT3 = strDT3.substr(0, 2) + "/" + strDT3.substr(2, 2) + "/" + strDT3.substr(4);
  }
  PINVHeader.push(strDT3);

  // Body Section
  var bodyRowData = {};
  var rowData;
  PINVDatatable.splice(0);
  var isCaseData = false;
  for (var count = 3; count < splitData.length; count++) {
    rowData = splitData[count];
    isCaseData = rowData.length > 1 ? (rowData.substr(0, 1) == "4" ? true : false) : false;
    if (isCaseData) {
      bodyRowData = {
        "CaseNumber": rowData.length >= 17 ? rowData.substr(13, 4) : "",
        "Distributor": rowData.length >= 13 ? rowData.substr(6, 7) : "",
        "PLNumber": rowData.length >= 6 ? rowData.substr(1, 5) : "",
        "NetWeight": rowData.length >= 23 ? (parseFloat(rowData.substr(17, 6)) / 100).toLocaleString("ja-JP", { minimumFractionDigits: 2 }) : "",
        "GrossWeight": rowData.length >= 29 ? (parseFloat(rowData.substr(23, 6)) / 100).toLocaleString("ja-JP", { minimumFractionDigits: 2 }) : "",
        "CubicMeasure": rowData.length >= 54 ? (parseFloat(rowData.substr(45, 9)) / 1000000).toLocaleString("ja-JP", { minimumFractionDigits: 6 }) : "",
        "ContainerNumber": rowData.length >= 45 ? rowData.substr(34, 11) : ""
      }
      PINVDatatable.push(bodyRowData);
      isCaseData = false;
    }
  }
  var dataHeight = PINVDatatable.length;
  var maxRowCount = 10;
  if (dataHeight > maxRowCount) {
    document.getElementById("tblPINVListHeader").style.width = "calc(100% - 16px)";
  } else {
    document.getElementById("tblPINVListHeader").style.width = "100%";
  }
};

const CaseDetailModalClick = (info) => {
  CaseDetailHeader.splice(0);
  CaseDetailHeader.push(info.CaseNumber)
  CaseDetailDatatable.splice(0);
  var bodyRowCount = CaseDetailSplitData.value.length - 3;
  var bodyRowData = {};
  var rowData, rowData1, rowData2, rowData3;
  var nextCaseNo = "";
  var isDetailExist = false;
  var headerSecOne = CaseDetailSplitData.value[1];
  var isJapanseCurrency = headerSecOne.length >= 16 ? (headerSecOne.substr(15, 1) == 'N') ? true : false : false;
  for (var count = 0; count < bodyRowCount; count++) {
    rowData = CaseDetailSplitData.value[count + 3];
    nextCaseNo = rowData.length >= 17 ? (rowData.substr(0, 1) == "4" ? rowData.substr(13, 4) : nextCaseNo) : "";

    if (nextCaseNo == info.CaseNumber) {
      rowData1 = CaseDetailSplitData.value[count + 4];
      rowData2 = CaseDetailSplitData.value[count + 5];
      isDetailExist = rowData1.length >= 1 && rowData2.length >= 1 ? (rowData1.substr(0, 1) == "6" && rowData2.substr(0, 1) == "7" ? true : false) : false;
      if (isDetailExist) {
        bodyRowData = {
          "OrderNumber": rowData1.length >= 7 ? rowData1.substr(1, 6) : "",
          "Item1": rowData1.length >= 11 ? rowData1.substr(7, 4) : "",
          "OrderPart": rowData1.length >= 26 ? rowData1.substr(11, 15) : "",
          "Qty": rowData1.length >= 56 ? parseInt(rowData1.substr(50, 6)) : "",
          "SalesNumber": rowData1.length >= 31 ? rowData1.substr(26, 5) : "",
          "Item2": rowData1.length >= 35 ? rowData1.substr(31, 4) : "",
          "ShippedPart": rowData1.length >= 50 ? rowData1.substr(35, 15) : "",
          "FOB": rowData1.length >= 66 ? isJapanseCurrency ? parseInt(rowData1.substr(59, 7)).toLocaleString() : (parseFloat(rowData1.substr(59, 7)) / 100).toLocaleString("ja-JP", { minimumFractionDigits: 2 }) : "",
          "WeightG": rowData1.length >= 75 ? (parseFloat(rowData1.substr(66, 9)) / 100).toLocaleString("ja-JP", { minimumFractionDigits: 2 }) : "",
          "Tariff": rowData2.length >= 42 ? rowData2.substr(31, 11) : "",
          "AsbestosFlag": "#",
          "Description": rowData2.length >= 31 ? rowData2.substr(1, 30) : ""
        };
        CaseDetailDatatable.push(bodyRowData);
        rowData3 = (count + 6) < bodyRowCount ? CaseDetailSplitData.value[count + 6] : "";
        count = rowData3.length >= 1 ? (rowData3.substr(0, 1) == "9" ? count + 2 : count + 1) : count + 1;
      }
      isDetailExist = false;
    }
  }
  var dataHeight = CaseDetailDatatable.length;
  var maxRowCount = 13;
  if (dataHeight > maxRowCount) {
    document.getElementById("tblCaseDetailListHeader").style.width = "calc(100% - 16px)";
  } else {
    document.getElementById("tblCaseDetailListHeader").style.width = "100%";
  }
};

/** 選択してるDataIdで表示非表示を判断する関数 */
const checkDataId = (file) => {
  if (
    file.dataId === selectDataId.value ||
    selectDataId.value === "ALL DATA ID"
  ) {
    return true;
  } else {
    return false;
  }
};

/** 遅延関数(nミリ秒遅延) */
const delayDownload = (n: number) => {
  return new Promise(function (resolve) {
    setTimeout(resolve, n);
  });
};

/** 1件ダウンロード時の処理関数 */
const pcDownload = async (file: FileData) => {
  if (isDownloaded.value == "notDownloaded") {
    isLoading.value = true;
    // DBのダウンロード済フラグをtrueにする
    controlIdList.splice(0);
    controlIdList.push(file.id);
    try {
      setDownloadFlag(file);
    } catch (e) {
      console.log(e);
      alertMessage.value = i18n.t("err002");
      alertState.value = "error";
      isLoading.value = false;
    }
  } else {
    isLoading.value = true;
    oneFileCsvDownload(file);
    isLoading.value = false;
  }
};

/** 1件CSVダウンロード時の処理関数 */
const oneFileCsvDownload = async (file: FileData | null) => {
  if (file != null) {
    isLoading.value = true;
    await delayDownload(100);
    isOnedownload.value = true;
    const blob = new Blob([file.fileBody], {
      type: "text/plain",
    });
    const downloadlink = document.createElement("a");
    const date = new Date();
    const downloadDate =
      ("00" + (date.getMonth() + 1)).slice(-2) +
      ("00" + date.getDate()).slice(-2) +
      date.getFullYear() +
      ("00" + date.getHours()).slice(-2) +
      ("00" + date.getMinutes()).slice(-2) +
      ("00" + date.getSeconds()).slice(-2);
    downloadlink.href = URL.createObjectURL(blob);
    downloadlink.download =
      file.id + "_" + file.dataId + "_" + downloadDate + ".txt";
    downloadlink.click();
    isLoading.value = false;
  }
};

/** ダウンロード済フラグをtrueにする関数 */
const setDownloadFlag = (fileData: FileData | null, batchCsvData = "") => {
  isLoading.value = true;
  alertMessage.value = "null";
  alertState.value = "neutral";
  // ダウンロードパータンによって、paramが違うため
  var param = {
    controlIdList: controlIdList,
    donwloadPattern: "OneFile",
    loginUserId: store.getters.cognitoUserName,
    toStationCode: selectedDestination.value,
  };
  if (fileData === null) {
    param.donwloadPattern = "AllFile";
  }
  PcFileDataService.setDownloadFlag(param)
    .then(async () => {
      if (param.donwloadPattern == "AllFile") {
        createText(batchCsvData);
      } else {
        oneFileCsvDownload(fileData);
      }
      if (fileData === null) {
        if (SCANAllRowtable[0].length > SCANSelectedOptionRows[0].length) {
          for (let idxVal = 0; idxVal < SCANSelectedOptionRows[0].length; idxVal++) {
            const indexVal0 = SCANAllRowtable[0].findIndex((object: any) => { return object === SCANSelectedOptionRows[0][idxVal]; });
            if (indexVal0 != -1) {
              SCANAllRowtable[0].splice(indexVal0, 1);
            }
          }
          SCANSelectedOptionRows.splice(0);
          resetShowData();
          isLoading.value = false;
        } else {
          SCANAllRowtable.splice(0);
          SCANSelectedOptionRows.splice(0);
          await Promise.all([
            getFilesByToStationCodeAllData()
          ]);
        }
      } else if (isDownloaded.value == "notDownloaded") {
        // SCANAllRowtableとSCANSelectedOptionRowsをクリアする
        const indexVal1 = SCANAllRowtable[0].findIndex((object: any) => { return object === fileData; });
        if (indexVal1 != -1) {
          SCANAllRowtable[0].splice(indexVal1, 1);
        }
        const indexVal2 = SCANSelectedOptionRows[0].findIndex((object: any) => { return object === fileData; });
        if (indexVal2 != -1) {
          SCANSelectedOptionRows[0].splice(indexVal2, 1);
        }
        // data that filtered by DataId remains nothing
        if (SCANSelectedOptionRows[0].length == 0 && SCANAllRowtable[0].length == 0) {
          isLoading.value = true;
          await Promise.all([
            getFilesByToStationCodeAllData()
          ]);
        } else {
          resetShowData();
          isLoading.value = false;
        }
      } else {
        isLoading.value = false;
      }
    })
    .catch((e: Error) => {
      console.log(e);
      controlIdList.splice(0);
      alertMessage.value = i18n.t("err005");
      alertState.value = "error";
      isLoading.value = false;
    });
};

/* Show Reset after Dowloading */
const resetShowData = () => {
  downloadFiles.splice(0);
  if ((SCANSelectedOptionRows.length == 0 || SCANSelectedOptionRows[0].length == 0) && SCANAllRowtable[0].length != 0) {
    SCANSelectedOptionRows.splice(0);
    SCANSelectedOptionRows.push(SCANAllRowtable[0]);
    selectDataId.value = "ALL DATA ID";
    uniqueDataID.splice(0);
    uniqueDataID.push([...new Set(SCANSelectedOptionRows[0].map((item1: { dataId: any; }) => item1.dataId))].sort());
    selectFromStation.value = "ALL STATION";
    uniqueFromStaion.splice(0);
    uniqueFromStaion.push([...new Set(SCANSelectedOptionRows[0].map((item2: { fromStationCode_id: any; }) => item2.fromStationCode_id))].sort());
  }
  SCANPageCount.value = Math.ceil(SCANSelectedOptionRows[0].length / SCANPageMaxRow.value);
  // After downloaing of Last Page that has only one row, check pageIndex > pageCount
  SCANPageNumber.value = SCANPageNumber.value > SCANPageCount.value ? SCANPageCount.value : SCANPageNumber.value;
  var startIndex = (SCANPageNumber.value - 1) * SCANPageMaxRow.value;
  var lastIndex = startIndex + SCANPageMaxRow.value;
  for (var idxVal = startIndex; idxVal < SCANSelectedOptionRows[0].length; idxVal++) {
    if (idxVal < lastIndex) {
      downloadFiles.push(SCANSelectedOptionRows[0][idxVal]);
    } else {
      break;
    }
  }
  SCANAllRowLenght.value = SCANSelectedOptionRows[0].length;
  SCANPageShowLenght.value = downloadFiles.length + (SCANPageMaxRow.value * (SCANPageNumber.value - 1));
};

/* DATAID変更イベント */
const dataIdChange = (event: { target: { value: any }; }) => {
  selectDataId.value = event.target.value;
  isLoading.value = true;
  dataIdAndStationFiltering();
  uniqueFromStaion.splice(0);
  uniqueFromStaion.push([...new Set(SCANSelectedOptionRows[0].map((item2: { fromStationCode_id: any; }) => item2.fromStationCode_id))].sort());
  if (uniqueFromStaion[0].findIndex((stCode: any) => { return stCode === selectFromStation.value; }) == -1) {
    selectFromStation.value = "ALL STATION";
  }
  isLoading.value = false;
};

/** From Station変更イベント */
const fromStationChange = (event: { target: { value: any; }; }) => {
  selectFromStation.value = event.target.value;
  isLoading.value = true;
  dataIdAndStationFiltering();
  uniqueDataID.splice(0);
  uniqueDataID.push([...new Set(SCANSelectedOptionRows[0].map((item1: { dataId: any; }) => item1.dataId))].sort());
  if (uniqueDataID[0].findIndex((stCode: any) => { return stCode === selectDataId.value; }) == -1) {
    selectDataId.value = "ALL DATA ID";
  }
  isLoading.value = false;
};

/** DATA IDとFROM STATIONのフィルター共通関数 */
const dataIdAndStationFiltering = () => {
  SCANSelectedOptionRows.splice(0);
  if (SCANAllRowtable.length != 0) {
    if (selectDataId.value != "ALL DATA ID" && selectFromStation.value != "ALL STATION") {
      SCANSelectedOptionRows.push(SCANAllRowtable[0].filter((file1: { dataId: any; fromStationCode: { stationCode: any; }; }) => file1.dataId == selectDataId.value && file1.fromStationCode_id == selectFromStation.value));
    } else if (selectDataId.value == "ALL DATA ID" && selectFromStation.value != "ALL STATION") {
      SCANSelectedOptionRows.push(SCANAllRowtable[0].filter((file2: { fromStationCode: { stationCode: any; }; }) => file2.fromStationCode_id == selectFromStation.value));
    } else if (selectDataId.value != "ALL DATA ID" && selectFromStation.value == "ALL STATION") {
      SCANSelectedOptionRows.push(SCANAllRowtable[0].filter((file4: { dataId: any; }) => file4.dataId == selectDataId.value));
    } else {
      SCANSelectedOptionRows.push(SCANAllRowtable[0]);
      if (selectDataId.value == "ALL DATA ID") {
        uniqueDataID.splice(0);
        uniqueDataID.push([...new Set(SCANSelectedOptionRows[0].map((item1: { dataId: any; }) => item1.dataId))].sort());
      }
      uniqueFromStaion.splice(0);
      uniqueFromStaion.push([...new Set(SCANSelectedOptionRows[0].map((item2: { fromStationCode_id: any; }) => item2.fromStationCode_id))].sort());
    }
    downloadFiles.splice(0);
    for (let i = 0; i < SCANSelectedOptionRows[0].length; i++) {
      if (i < SCANPageMaxRow.value) {
        var date1 = new Date(Date.parse(SCANSelectedOptionRows[0][i].uploadDate));
        SCANSelectedOptionRows[0][i].uploadDate = date1.toLocaleString("en-US", { hour12: false });
        downloadFiles.push(SCANSelectedOptionRows[0][i]);
      } else {
        break;
      }
    }
    SCANPageCount.value = Math.ceil(SCANSelectedOptionRows[0].length / SCANPageMaxRow.value);
    SCANPageNumber.value = 1;
    SCANAllRowLenght.value = SCANSelectedOptionRows[0].length;
    SCANPageShowLenght.value = downloadFiles.length;
  }
};

/** 表示しているData IDのダウンロードデータ件数を返す関数 */
const countDownloadData = (fileList, dataId) => {
  let result = [];
  if (fileList.length != 0) {
    if (dataId != "ALL DATA ID") {
      result = fileList[0].filter((file) => file.dataId == dataId);
    } else {
      result = fileList[0];
    }
    return result.length;
  }
};

onUpdated(function () {
  if (isOnedownload.value) {
    isOnedownload.value = false;
  }
  store.dispatch("setSelectedStation", selectedDestination.value);
  var tableHeight = 0;
  var dataHeight = document.getElementById("tbodyDownload")?.clientHeight;
  if (dataHeight != 0) {
    var mydivh = document.getElementById("mainDiv")?.clientHeight;
    tableHeight = (mydivh * 96) / 100 - 400;
    if (dataHeight > tableHeight) {
      document.getElementById("divBodayDownload").style.width = "80vw";
    } else {
      document.getElementById("divBodayDownload").style.width = "calc(80vw - 16px)";
    }
  }
});

const __returned__ = { downloadFiles, uniqueDataID, uniqueFromStaion, fileBody, isDownloaded, selectDataId, selectFromStation, isLoading, controlIdList, alertMessage, alertState, i18n, isOnedownload, isAuthUser, isEnableDownload, isDownloadFileLoaded, isDownloadBannerMsg, startDate, endDate, SCANAllRowtable, SCANPageMaxRow, SCANPageCount, SCANPageNumber, SCANNextBtnText, SCANBackBtnText, SCANSelectedOptionRows, SCANAllRowLenght, SCANPageShowLenght, PORDTitle, PORDHeader, PORDDatatable, PORDTenRowtable, PORDPageCount, PORDPageNumber, PORDBackBtnText, PINVTitle, PINVHeader, PINVDatatable, CaseDetailTitle, CaseDetailDatatable, CaseDetailHeader, CaseDetailSplitData, destinationList, selectedDestination, pcBatchDownload, createText, startDateChange, blockInput, getFilesByToStationCodeAllData, getFilesByToStationCode, changeSCANPage, modalClick, PORDModalClick, changePORDPage, PINVModalClick, CaseDetailModalClick, checkDataId, delayDownload, pcDownload, oneFileCsvDownload, setDownloadFlag, resetShowData, dataIdChange, fromStationChange, dataIdAndStationFiltering, countDownloadData, Navigation, store, Loading, Alert, Manual }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})